var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStressNewEntry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#febe10;}.cls-2{fill:#fffbc5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stress_new_entry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_99",
    "data-name": "Layer 99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "litter_expenses_new_entry",
    "data-name": "litter expenses new entry"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300.01,
    cy: 300.38,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.33,244.93H357.06V159.75a56.18,56.18,0,0,0-56-56h0a56.2,56.2,0,0,0-56,56v85.18H164.84a56.2,56.2,0,0,0-56,56h0a56.2,56.2,0,0,0,56,56H245V442.2a56.2,56.2,0,0,0,56,56h0a56.2,56.2,0,0,0,56-56V357h90.27a56.18,56.18,0,0,0,56-56h0A56.19,56.19,0,0,0,447.33,244.93Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressNewEntry);
export default __webpack_public_path__ + "static/media/stress_new_entry.30b1356315e8ca70846d1dbc50dd8bc1.svg";
export { ForwardRef as ReactComponent };